import * as types from "../../../constants";

const initialState = {
  loading: false,
  measurementInfoLoading: false,
  testList: [],
  currentTest: {},
  filteredTestList: [],
  filterSettings: {
    duplicate: 0,
    anomaly: 0,
    all: 1,
  },
  filterEnabled: false,
  sort: { order: "desc", orderBy: "measurementStarted" },
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case types.TEST_SORT:
      return {
        ...state,
        sort: { order: action.payload.order, orderBy: action.payload.orderBy },
      };
    case types.TEST_LOADING:
      return {
        ...state,
        loading: true,
      };
    case types.MEASUREMENT_INFO_LOADING:
      return {
        ...state,
        measurementInfoLoading: true,
      };
    case types.TEST_LOADING_DISABLE:
      return {
        ...state,
        loading: false,
      };
    case types.MEASUREMENT_INFO_LOADING_DISABLE:
      return {
        ...state,
        measurementInfoLoading: false,
      };
    case types.RETRIEVE_TEST_LIST:
      return {
        ...state,
        testList: [...action.payload],
        loading: false,
      };
    case types.RETRIEVE_TEST_INFO:
      return {
        ...state,
        currentTest: { ...action.payload },
        loading: false,
      };
    case types.UPDATE_MEASUREMENT_INFO:
      const updatedTest = Object.assign(state.currentTest, action.payload);

      return {
        ...state,
        currentTest: updatedTest,
        measurementInfoLoading: false,
      };
    case types.CURRENT_TEST:
      return {
        ...state,
        currentTest: action.payload,
      };
    case types.DELETE_TEST:
      let newTestList = [];

      newTestList = state.testList.filter(
        (test) => test.testId !== action.payload
      );

      return {
        ...state,
        testList: [...newTestList],
        loading: false,
      };
    case types.TEST_FILTER:
      let duplicatesList = [];
      let anomaliesList = [];

      if (action.payload.duplicate) {
        duplicatesList = state.testList.filter((test) => test.duplicateTest);
      }

      if (action.payload.anomaly) {
        anomaliesList = state.testList.filter((test) =>
          test.anomalies.includes(1)
        );
      }

      if (action.payload.all) {
        return {
          ...state,
          filteredTestList: [],
          filterEnabled: false,
          filterSettings: {
            duplicate: 0,
            anomaly: 0,
            all: 1,
          },
        };
      }

      const filteredTestList = duplicatesList.concat(anomaliesList);
      const uniqueList = Array.from(new Set(filteredTestList));

      return {
        ...state,
        filteredTestList: uniqueList,
        filterEnabled: true,
        filterSettings: { ...action.payload },
      };
    case types.RESET_TEST_LIST:
      return {
        ...state,
        currentTest: {},
        testList: [],
      };
    default:
      return state;
  }
};

export default reducer;
